import restApi from "@plannel/services/utils/rest-api";

const getScheduleLog = (params) => {
    return restApi.get("/api/quartz-schedule/log", { params });
}

const scheduleLogService = {
    getScheduleLog
}

export default scheduleLogService;